import API from "../Api";

export const apiCoupon = (body) => API.post(`/api/v1/coupon/validate`, body)

